import { z } from "zod";
import { NOTE } from "./consts";

export const schema = z.object({
  [NOTE]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
